import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelfStudyRoutingModule } from './self-study-routing.module';
import { SharedComponentsModule } from '../../../shared/shared-component.module';
import { SelfStudyComponent } from './self-study.component';
import { BlockInfoComponent } from '../../../components/block-info/block-info.component';
import { BoxModule } from 'angular-admin-lte';
import { BoxInfoModule as MkBoxInfoModule } from 'angular-admin-lte';
import { AccordionModule as MkAccordionModule } from 'angular-admin-lte';
import { SelfStudyAccordionComponent } from '../../../components/accordion-self-study/accordion-self-study.component';

@NgModule({
  imports: [
    CommonModule,
    SelfStudyRoutingModule,
    MkAccordionModule,
    BoxModule,
    MkBoxInfoModule,
    SharedComponentsModule,
  ],
  declarations: [
    SelfStudyComponent,
    BlockInfoComponent,
    SelfStudyAccordionComponent,
  ],
})
export class SelfStudyModule {}
